import * as yup from 'yup';

const hpSchema = yup.object({
  s_hpName         : yup.string().required('Le nom du vaccinateur est manquant'),
  s_hpGiven        : yup.string().required('Le prénom du vaccinateur est manquant'),
  s_hpProfession   : yup.string().required('La profession du vaccinateur est manquant'),
  s_hpProfessionOid: yup.string().required('L\'oid de profession du vaccinateur est manquant'),
  s_hpSpeciality   : yup.string(),
  s_hpInternalId   : yup.string().required('L\'identifiant du vaccinateur est manquant'),
  s_hpInstitution  : yup.string(),
  Institution      : yup.object({
    s_classCode: yup.string().required('Le cadre d\'exercice est manquant'),
    s_id       : yup.string().required('L\'identifiant de la structure est manquant'),
    s_name     : yup.string().required('Le nom de la structure est manquant')
  }).notRequired().default(undefined),
});

export const immunizationDefaultValues = {
  i_approachSite     : 0,
  i_doseQuantity     : undefined,
  i_immunizationRoute: 0,
  i_rank             : undefined,
  i_type             : 1,
  Comment            : {
    s_text: ''
  },
  Consumable         : {
    s_atcCode  : '',
    s_cisCode  : '',
    s_lotNumber: '',
    s_name     : ''
  },
  Performer          : undefined,
  Author             : undefined,
};

export const immunizationSchema = yup.object({
  i_approachSite     : yup.number(),
  i_doseQuantity     : yup.number(),
  i_immunizationRoute: yup.number(),
  i_rank             : yup.number(),
  i_type             : yup.number(),
  Comment            : yup.object({
    s_text: yup.string()
  }).notRequired().default(undefined),
  Consumable         : yup.object({
    s_atcCode  : yup.string().required('Le code ATC du produit est manquant'),
    s_cisCode  : yup.string().required('Le code CIS du produit est manquant'),
    s_lotNumber: yup.string().required('Le numéro de lot du produit est manquant'),
    s_name     : yup.string()
  }).required('Le produit est manquant'),
  Performer          : hpSchema.required('Le vaccinateur est manquant'),
  Author             : hpSchema.notRequired().default(undefined),
});
